import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8c61c3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "giant-voice-container" }
const _hoisted_2 = { class: "built-dialog" }
const _hoisted_3 = { class: "clear-wrapper" }
const _hoisted_4 = { class: "flex mb-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("CLEAR ALL ")
const _hoisted_6 = { class: "options" }

import ButtonComponent from '@/components/ButtonComponent.vue';
import Icon from '@/components/icon/Icon';
import { BuildableDialogItem } from '@/models/BuildableDialogItem';
import { Ref, ref } from 'vue';
import BuildableDialogItemComponent from '@/components/system/components/BuildableDialogItemComponent.vue';
import IconComponent from '../../../icon/IconComponent.vue';
import { CommandType } from './type';
import { undo } from './undo';
import { redo } from './redo';


export default /*#__PURE__*/_defineComponent({
  __name: 'BuildableDialogueBodyWidget',
  props: {
    availableDialog: null,
    builtDialogMessage: null
  },
  emits: ['addDialog', 'clear', 'removeDialog'],
  setup(__props: any, { emit }) {

const props = __props as {
  availableDialog: BuildableDialogItem[];
  builtDialogMessage: BuildableDialogItem[];
}



const commandStack: Ref<CommandType[]> = ref([]);
const inverseCommandStack: Ref<CommandType[]> = ref([]);



const REMOVABLE_INDEX = -1;
const removeableIndex = ref(REMOVABLE_INDEX);

const isRemovable = (index: number) => {
  return removeableIndex.value === index;
};

const removeDialogFromBuiltDialogMessage = (index: number) => {
  if (removeableIndex.value === index) {
    commandStack.value.push({
      type: 'remove',
      items: [props.builtDialogMessage[index]],
      index
    });
    emit('removeDialog', index);
    removeableIndex.value = REMOVABLE_INDEX;
  } else {
    removeableIndex.value = index;
  }
};

const clearBuiltDialog = () => {
  commandStack.value.push({
    type: 'clear',
    items: [...props.builtDialogMessage],
    index: 0
  });
  emit('clear');
  removeableIndex.value = REMOVABLE_INDEX;
};

const addDialog = (dialogItem: BuildableDialogItem) => {
  const lastCommand = commandStack.value[commandStack.value.length - 1];
  if (
    lastCommand &&
    (lastCommand.type === 'remove' || lastCommand.type === 'clear')
  ) {
    commandStack.value = [];
    inverseCommandStack.value = [];
  }
  commandStack.value.push({
    type: 'add',
    items: [dialogItem],
    index: props.builtDialogMessage.length - 1
  });
  emit('addDialog', dialogItem);
};

function undoHandler() {
  undo(props.builtDialogMessage, commandStack.value, inverseCommandStack.value);
}

function redoHandler() {
  redo(props.builtDialogMessage, commandStack.value, inverseCommandStack.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _renderSlot(_ctx.$slots, "title"),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.builtDialogMessage, (dialogItem, index) => {
        return (_openBlock(), _createBlock(BuildableDialogItemComponent, {
          class: _normalizeClass(["ml-1 mr-0", { removable: isRemovable(index) }]),
          "color-mode": "light",
          active: true,
          key: index,
          "dialog-item": dialogItem,
          index: index,
          onSelectDialogItem: ($event: any) => (removeDialogFromBuiltDialogMessage(index))
        }, null, 8, ["dialog-item", "index", "class", "onSelectDialogItem"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ButtonComponent, {
          "data-testid": "clear-button",
          "color-type": "tertiary",
          size: "medium",
          onClick: clearBuiltDialog
        }, {
          default: _withCtx(() => [
            _createVNode(IconComponent, {
              icon: _unref(Icon).TRASH,
              class: "mr-2"
            }, null, 8, ["icon"]),
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(ButtonComponent, {
          class: "w-auto ml-2",
          "data-testid": "undo-button",
          "color-type": "primary",
          size: "medium",
          onClick: undoHandler,
          disabled: !commandStack.value.length
        }, {
          default: _withCtx(() => [
            _createVNode(IconComponent, {
              icon: _unref(Icon).UNDO
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(ButtonComponent, {
          class: "w-auto ml-2",
          "data-testid": "redo-button",
          "color-type": "primary",
          size: "medium",
          onClick: redoHandler,
          disabled: !inverseCommandStack.value.length
        }, {
          default: _withCtx(() => [
            _createVNode(IconComponent, {
              icon: _unref(Icon).REDO
            }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _renderSlot(_ctx.$slots, "reply"),
      _renderSlot(_ctx.$slots, "subtitle")
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.availableDialog, (dialogItem, index) => {
        return (_openBlock(), _createBlock(BuildableDialogItemComponent, {
          key: index,
          "dialog-item": dialogItem,
          index: index,
          onSelectDialogItem: ($event: any) => (addDialog(dialogItem))
        }, null, 8, ["dialog-item", "index", "onSelectDialogItem"]))
      }), 128))
    ]),
    _renderSlot(_ctx.$slots, "controls")
  ]))
}
}

})